export enum WebSocketPayloadActionData {
  REQUEST = 'DATA_REQUEST',
  UPDATE = 'UPDATE_REQUEST',
  DELETE = 'DELETE_REQUEST'
}
